import { FC, ReactNode } from 'react';
import { Box } from '@mui/material';

interface Props {
  children?: ReactNode;
  tabIndex: number;
}

const TabPanel: FC<Props> = ({ children, tabIndex }) => {
  return (
    <Box
      role="tabpanel"
      id={`full-width-tabpanel-${tabIndex}`}
      aria-labelledby={`full-width-tab-${tabIndex}`}
      flexGrow={1}
      pt={3}
    >
      {children}
    </Box>
  );
};

export default TabPanel;
